import React from "react";
import styles from "./style.module.css";

import AWSTier from "images/AWS-tier.png";
import AWSLogin from "images/AWS-login.png";
import AWSAccountID from "images/AWS-accountID.png";
import AWSLink from "images/AWS-link.png";
import AWSCloud from "images/AWS-cloud.png";
import AWSValidation from "images/AWS-validation.png";
import AWSSelect from "images/AWS-select.png";
import AWSDone from "images/AWS-done.png";

export default class AWSHelp extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className={styles.body}>
          <div className={styles.AWSHelpWrapper} onScroll={this.handleScroll}>
            <h2 className={styles.listTitle}>Part 1: Signing up for AWS</h2>
            <ol>
              <li className={styles.listItem}>
                Signup for a new AWS account at{" "}
                <a href="https://aws.amazon.com" target="_blank">
                  aws.amazon.com
                </a>
                . You do not need to configure any details other than your billing information and confirm your
                identity. You will need your AWS Account ID from your new account which is on the “My Account”
                page.{" "}
              </li>
              <hr className={styles.divider} />
              <li className={styles.listItem}>You can select the Free tier from AWS.</li>
              <img
                className={`${styles.center} ${styles.helpImage} ${styles.animateZoom}`}
                style={{ maxHeight: "400px" }}
                src={AWSTier}
                alt="Select AWS free tier"
              />
              <hr className={styles.divider} />
              <li className={styles.listItem}>
                It may take AWS a few minutes to email you your account registration. Or you can log in from the AWS
                page.
              </li>
              <img
                className={`${styles.center} ${styles.helpImage} ${styles.animateZoom}`}
                style={{ maxHeight: "135px" }}
                src={AWSLogin}
                alt="Login to AWS"
              />
              <hr className={styles.divider} />
            </ol>
            <h2 className={styles.listTitle}>Part 2: Linking Your AWS Account to Aible</h2>
            <ol>
              <li className={styles.listItem}>
                In Aible go to your Account Settings by clicking on the gear in the top right corner. Then, click “New
                Account”. You will be prompted to enter your AWS Account ID and Name and then will be linked to a new
                window in AWS. This information can be found in the “My Account” section of your AWS Console.
              </li>
              <img
                className={`${styles.center} ${styles.helpImage} ${styles.animateZoom}`}
                style={{ maxHeight: "200px" }}
                src={AWSAccountID}
                alt="Enter AWS Account ID"
              />
              <hr className={styles.divider} />
              <li className={styles.listItem}>Click on the link to complete the account linking.</li>
              <img
                className={`${styles.center} ${styles.helpImage} ${styles.animateZoom}`}
                style={{ maxHeight: "250px" }}
                src={AWSLink}
                alt="Link AWS account to Aible"
              />
              <hr className={styles.divider} />
              <li className={styles.listItem}>
                If you are not signed in to AWS, you will be prompted with the AWS login page. Note that you are not
                prompted for any AWS passwords or secret keys in Aible – Aible does not store your AWS user name or
                password and only stores your AWS account ID in your Aible account settings.
              </li>
              <hr className={styles.divider} />
              <li className={styles.listItem}>
                You will now be in the AWS CloudFormation page. This form is already completed for you and is ready to
                create the Aible AI operations stack in your account. At the bottom of the page, you will click the
                checkbox to allow the Aible CloudFormation template to create IAM security roles and then click the
                confirmation button.
              </li>
              <img
                className={`${styles.center} ${styles.helpImage} ${styles.animateZoom}`}
                style={{ maxHeight: "500px" }}
                src={AWSCloud}
                alt="Create Aible AI operations stack in AWS CloudFormation"
              />
              <hr className={styles.divider} />
              <li className={styles.listItem}>
                The form will take a moment to complete. After finishing validation, you should see this screen.
              </li>
              <img
                className={`${styles.center} ${styles.helpImage} ${styles.animateZoom}`}
                style={{ maxHeight: "250px" }}
                src={AWSValidation}
                alt="AWS Validation screen"
              />
              <hr className={styles.divider} />
              <li className={styles.listItem}>
                Go back to Aible, and you should see that your AWS account is active and linked.
              </li>
              <hr className={styles.divider} />
              <li className={styles.listItem}>
                Click on the AWS account, instead of the Aible Sample Account, to select and use it. You can confirm
                that is selected. Back on the home screen, your AWS account will appear in the top right corner.
              </li>
              <img
                className={`${styles.center} ${styles.helpImage} ${styles.animateZoom}`}
                style={{ maxHeight: "200px" }}
                src={AWSSelect}
                alt="Select your newly linked AWS account"
              />
              <hr className={styles.divider} />
              <li className={styles.listItem}>
                Now you can proceed to upload your data to your AWS account and create your first Real World AI on it
              </li>
              <img
                className={`${styles.center} ${styles.helpImage} ${styles.animateZoom}`}
                style={{ maxHeight: "250px" }}
                src={AWSDone}
                alt="Aible is ready to go"
              />
            </ol>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
